import { useDispatch, useSelector } from "react-redux"
import { useNavigate, useParams } from "react-router"
import { RoleType } from "../../../App/enums"
import { organizationProfileDefault, profileDefault } from "../../../App/GlobaleVariables"
import { selectTranslations } from "../../../App/i18n/i18nSlice"
import { RootState } from "../../../App/store"
import Image from "../../Shared/Primitive/Image"
import { setModalData } from "../../Shared/SharedSlices/ModalSlice"

function ManagersCard() {
    const { id } = useParams()
    const dispatch = useDispatch()
    const navigate = useNavigate()
    const translation = useSelector(selectTranslations)
    const role = useSelector((state: RootState) => state.rolesSlice.RolesSlice.roles)
    const roomDataState = useSelector((state: RootState) => state.roomSlice.roomSlice.room)
    const userDataState = useSelector((state: RootState) => state.userDataSlice)

    const onRoomManagerClick = (roomManagerId: number, isUser: boolean) => {
        dispatch(setModalData({ open: false, roomMembersModal: false }))
        switch (role) {
            case RoleType.USER:
                if (isUser && roomManagerId === userDataState.id) {
                    navigate("/user-profile")
                    window.scrollTo(0, 0)
                } else if (isUser) {
                    navigate(`/user/${roomManagerId}`)
                    window.scrollTo(0, 0)
                } else {
                    // Handle organization click if needed
                    navigate(`/organization-profile/${roomManagerId}`)
                    window.scrollTo(0, 0)
                }
                break
            case RoleType.ORGANIZATION:
                if (isUser && roomManagerId === userDataState.id) {
                    navigate("/user-profile")
                    window.scrollTo(0, 0)
                } else if (isUser) {
                    navigate(`/user/${roomManagerId}/${id}`)
                    window.scrollTo(0, 0)
                } else {
                    // Handle organization click if needed
                    navigate(`/organization-profile/${roomManagerId}`)
                    window.scrollTo(0, 0)
                }
                break
            default:
                break
        }
    }
    return (
        <div className="managers-card">
            <div className="managers-card__container">
                {roomDataState.room_managers?.map(roomManager => 
                    roomManager.type === "user" ? (
                        <div key={roomManager.id} className="managers-card__outer-container" onClick={() => onRoomManagerClick(roomManager.id,true)}>
                            <Image
                                src={roomManager?.profile_photo?.url_path || profileDefault}
                                className="image image__profile image__profile--fit image__profile--size-small"
                            />
                            <span className="managers-card__full-name">{roomManager.first_name + " " + roomManager.last_name}</span>
                            <p className="managers-card__outer-name">{(roomManager.first_name!.length > 13 ? 
                                  (roomManager.first_name!.charAt(0) + ". ") :  roomManager.first_name )
                                   + " " + roomManager.last_name!.charAt(0) + ". "}
                            </p>
                        </div>
                    ) : (
                        <div key={roomManager.id} className="managers-card__outer-container" onClick={() => onRoomManagerClick(roomManager.id,false)}>
                            <Image
                                src={roomManager?.profile_photo?.url_path || organizationProfileDefault}
                                className="image image__profile image__profile--fit image__profile--size-small"
                            />
                            <span className="managers-card__full-name">{roomManager.name}</span>
                            <p className="managers-card__outer-name">{(roomManager.name)}
                            </p>
                        </div>
                    )
                )}
            </div>
            <div className="managers-card__title">{translation.roomManagers}</div>
        </div>
    )
}

export default ManagersCard
